// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1saFj","messages":"Chat_messages__1wt2N","dateDivider":"Chat_dateDivider__1Fvql"};